import { createFileRoute } from "@tanstack/react-router";
import AdminSurveysPage from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys")({
  component: AdminSurveysPage,
});
